import {useEffect} from 'react'
import {LOCAL_STORAGE_ACCESS_TOKEN} from '@/features/auth/constants'
import {updateSocketAuth} from '@/socket'

/**
 * Hook to initialize the socket authentication
 * It ensures that the socket connection is authenticated with the current user token
 */
export const useInitSocketAuth = () => {
    useEffect(() => {
        // Get the token from localStorage
        const token = localStorage.getItem(LOCAL_STORAGE_ACCESS_TOKEN)

        // Update the socket authentication with the token
        if (token) {
            updateSocketAuth(token)
        }
    }, [])
}
